import React from 'react';

const KnotSide = () => (
  <img
    src="/assets/inerva-knot.png"
    alt=""
    aria-hidden="true"
    className="absolute top-1/2 -translate-y-1/2 right-0 translate-x-1/2 w-40 h-auto opacity-10 pointer-events-none hidden lg:block"
  />
);

const team = [
  {
    name: 'Ana Ruiz',
    role: 'Psicóloga General Sanitaria',
    photo: '/assets/ana-ruiz.png',
    description: 'Especializada en ansiedad, crisis vitales, procesos de identidad y acompañamiento afirmativo LGTBIQA+.',
  },
  {
    name: 'Pablo Pérez',
    role: 'Psicólogo General Sanitario',
    photo: '/assets/pablo-perez.png',
    description: 'Especializado en ansiedad, estrés, autoestima, relaciones y acompañamiento desde perspectiva de género.',
  },
];

export default function Team() {
  return (
    <section id="equipo" className="section-padding bg-white relative overflow-hidden">
      <KnotSide />
      <div className="container-narrow relative">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-forest)] opacity-70 mb-4 uppercase">
            Nuestro equipo
          </span>
          <h2 className="mb-4">Quiénes somos</h2>
          <p className="text-[var(--color-inerva-text-light)] max-w-2xl mx-auto">
            Dos psicólogos sanitarios comprometidos con un acompañamiento cercano, ético y basado en evidencia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 max-w-3xl mx-auto">
          {team.map((member, i) => (
            <div key={i} className="text-center">
              <div className="w-56 h-56 mx-auto mb-6 rounded-full overflow-hidden bg-[var(--color-inerva-mint)] group cursor-pointer">
                <img
                  src={member.photo}
                  alt={member.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-500"
                />
              </div>
              <h3 className="text-2xl mb-1 font-serif">{member.name}</h3>
              <p className="text-[var(--color-inerva-forest)] font-medium text-sm mb-3">{member.role}</p>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed max-w-xs mx-auto">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
